// Mitigação do bug de 26/07/2026 (WebView iOS): PDFs internos abertos com
// target=_blank (ex.: /exemplo-atestado.pdf) carregavam DENTRO da WebView do
// app nativo — o visualizador de PDF do WKWebView não tem botão de voltar e o
// wrapper ainda persistia o PDF como "última tela", prendendo o usuário no
// documento mesmo após fechar e reabrir o app. O mesmo vale para os
// short-links /d/<token> de documentos médicos (PDF com Content-Disposition:
// attachment), que a WKWebView não consegue tratar e derrubavam o usuário na
// tela de erro do wrapper.
//
// Quando o app nativo expõe uma bridge, a abertura é delegada ao navegador do
// sistema (Safari/Chrome). Em navegador comum não interfere: sem bridge, o
// comportamento padrão do link segue valendo.

/**
 * Abre a URL no navegador do sistema via bridge nativa, se disponível.
 * @returns {boolean} true se a bridge tratou a abertura.
 */
export function openUrlExternalInApp(rawUrl) {
  try {
    const url = new URL(rawUrl, window.location.origin).toString();

    if (typeof window.AndroidBridge?.openExternal === 'function') {
      window.AndroidBridge.openExternal(url);
      return true;
    }

    if (window.webkit?.messageHandlers?.consultaMaisBridge) {
      window.webkit.messageHandlers.consultaMaisBridge.postMessage({
        action: 'openExternal',
        url,
      });
      return true;
    }
  } catch {
    // Qualquer falha: deixa o comportamento padrão do link acontecer.
  }
  return false;
}

/** Handler de onClick para âncoras: delega à bridge nativa quando presente. */
export function openDocExternalInApp(event) {
  const href = event.currentTarget?.getAttribute('href');
  if (!href) return;
  if (openUrlExternalInApp(href)) event.preventDefault();
}
